import React from "react";

const WhatsAppFloating = ({
  phone = "5493795003578",
  message = "Hola! Tengo una consulta sobre SobreDigital 😊",
}) => {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-5 right-5 z-50"
    >
      <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 transition-all">
        <svg
          viewBox="0 0 32 32"
          width="26"
          height="26"
          fill="white"
        >
          <path d="M19.11 17.27c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.43-2.25-1.37-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.61-1.47-.83-2.01-.22-.53-.44-.46-.61-.47l-.52-.01c-.18 0-.49.07-.74.35-.25.28-.97.95-.97 2.31 0 1.36.99 2.67 1.13 2.85.14.18 1.95 2.98 4.73 4.18.66.29 1.18.46 1.58.59.66.21 1.26.18 1.73.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.21.16-1.32-.07-.11-.25-.18-.53-.32zM16 3C9.38 3 4 8.38 4 15c0 2.39.7 4.62 1.9 6.5L4 29l7.66-1.86A11.93 11.93 0 0016 27c6.62 0 12-5.38 12-12S22.62 3 16 3z"/>
        </svg>
      </div>
    </a>
  );
};

export default WhatsAppFloating;